import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { CookiesProvider } from "react-cookie";

//Sentry error tracking
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

if(process.env.NODE_ENV !== "development"){
Sentry.init({
  dsn: "https://efe248d4a0f04924b1725bdbe5d74972@o881803.ingest.sentry.io/5855564",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});
}

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <App />
    </CookiesProvider>

  </React.StrictMode>
  ,
  document.getElementById('root')
);

serviceWorker.unregister();
